/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ThgChurnControllerGetAllPaginatedParamsGen,
  ThgChurnViewModelGen,
  ThgPageViewModelGen
} from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class Churn<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags churn
   * @name ChurnControllerGetAllPaginated
   * @summary Get paginated churn data
   * @request GET:/churn
   * @secure
   * @response `200` `(ThgPageViewModelGen & { data?: (ThgChurnViewModelGen)[] })`
   */
  churnControllerGetAllPaginated = (query: ThgChurnControllerGetAllPaginatedParamsGen, params: RequestParams = {}) =>
    this.http.request<ThgPageViewModelGen & { data?: ThgChurnViewModelGen[] }, any>({
      path: `/churn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
}
